import React, { Component } from 'react';
import { connect } from 'react-redux';
import Navigation from './Navigation/Navigation';
import { createBrowserHistory } from 'history';

class App extends Component {
  render() {
    const replaceHashPath = () => {
      const history = createBrowserHistory();
      const hash = history.location.hash;
      if (hash) {
        const path = hash.replace(/^#/, '');
        if (path) {
          history.replace(path);
        }
      }
    };
    replaceHashPath();

    return (
      <div>
        <Navigation />
      </div>
    );
  }
}
export default connect()(App);
